// extracted by mini-css-extract-plugin
export default {"minis__img":"_Minis_minis__img__7ZxVC"};